module.exports = __webpack_public_path__ + "static/media/shed.c3a39fd2.webp";